/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_LeadInputs */



/**
* | output |
* | --- |
* | "Enter the email address your agency has on file. We will send you a sign-in link, so you do not need a password." |
*
* @param {Portalsignin_LeadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalsignin_lead = /** @type {((inputs?: Portalsignin_LeadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_LeadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Enter the email address your agency has on file. We will send you a sign-in link, so you do not need a password.")
});